import { BookingState } from 'fitbeat.models';
import {
    UserProfile,
    WorkoutSettings,
} from '../user';

export interface IGymstateAnalyticsRow {
    workoutRef: string;
    classId: string;
    user: UserProfile;
    partnerUserId: string;
    settings: WorkoutSettings;
    createdAt: Date;
    dateOfBooking: Date;
    checkinDate?: Date;
    cancelled: boolean;
    anonymised: boolean;
    checkinSkippedBiometric: boolean;
    bookingState: BookingState;
    workoutDurationInMinutes: number;
    availableSlotsAtTimeOfBooking: number;
    isPeak: boolean;
    gymLocation: string;
    workoutSelectionId: string;
    userRating?: number;
    userComment?: string;
    calories?: number;
    effortPoints?: number;
    startTime: Date;
    displayName?: string;
}

export class GymstateAnalytics {
    public gymstateAnalyticsRows: IGymstateAnalyticsRow[] = [];
    private readonly seperator = ',';
    private readonly header = [
        'Date',
        'Nickname',
        'EffortPoints',
        'Calories',
        'UserEmail',
        'Fullname',
        'HRMon',
        'Location',
    ];

    public csvHeader(): string {
        return this.header.join(this.seperator);
    }

    public csvBody(gymstateAnalyticsRows?: IGymstateAnalyticsRow[] ): string {
        const rowsList = this.handleGymStateData(gymstateAnalyticsRows ?
            gymstateAnalyticsRows :
            this.gymstateAnalyticsRows);
        const csvString = rowsList.join('\n');
        return csvString;
    }

    public add(row: IGymstateAnalyticsRow) {
        this.gymstateAnalyticsRows.push(row);
    }

    private handleGymStateData(gymstateAnalyticsRows: IGymstateAnalyticsRow[]): string[][] {
        const rowsList: string[][] = [];
        gymstateAnalyticsRows.filter((r) => !r.cancelled,
        ).forEach((row: IGymstateAnalyticsRow) => {
            const values: string[] = [];
            values.push(
                row.dateOfBooking.toISOString(),
                row.user.nickname,
                row.effortPoints != null ? row.effortPoints.toString() : '',
                row.calories != null ? row.calories.toString() : '',
                row.user.email,
                row.user.fullname,
                row.user.heartRateMonitorIdentifier,
                row.gymLocation,
            );
            rowsList.push(values);
        });
        return rowsList;
    }
}
